import api from './api';

export const reportService = {
  getDashboard: (params = {}) => api.get('/reports/dashboard', { params }),
  getRevenue: (params = {}) => api.get('/reports/revenue', { params }),
  getProjects: (params = {}) => api.get('/reports/projects', { params }),
  getLeads: (params = {}) => api.get('/reports/leads', { params }),
  getCustomers: (params = {}) => api.get('/reports/customers', { params }),
  getPeriodComparison: (period = 'last_30_days') => api.get('/reports/period-comparison', { params: { period } }),
  getEstimatedRevenueDetails: (params = {}) => api.get('/reports/estimated-revenue/details', { params }),
  getActiveProjects: () => api.get('/reports/active-projects'),
  getProjectsSold: (params = {}) => api.get('/reports/projects-sold', { params }),
  getProjectsStarted: (params = {}) => api.get('/reports/projects-started', { params }),
  getProjectsFinished: (params = {}) => api.get('/reports/projects-finished', { params }),
  getCostsAndWages: (params = {}) => api.get('/reports/costs-and-wages', { params }),
  editCostItem: (data) => api.put('/reports/costs-and-wages/item', data),
};
